import { StatusItem } from "@types";
import { createContext, useContext, useState } from "react";
import { FilterState } from "../@types/services/inspStatusService";

interface StatusContextType {
  selectedStatus: StatusItem | null;
  setSelectedStatus: React.Dispatch<React.SetStateAction<StatusItem | null>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  imageList: StatusItem[] | null;
  setImageList: React.Dispatch<React.SetStateAction<StatusItem[] | null>>;
  filters: FilterState;
  setFilters: React.Dispatch<React.SetStateAction<FilterState>>;
  totalDataCount: number;
  setTotalDataCount: React.Dispatch<React.SetStateAction<number>>;
}

const StatusContext = createContext<StatusContextType | undefined>(undefined);

export const StatusProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedStatus, setSelectedStatus] = useState<StatusItem | null>(null);
  const [page, setPage] = useState(1);
  const [imageList, setImageList] = useState<StatusItem[] | null>(null);

  const [filters, setFilters] = useState<FilterState>({
    name: "",
    material: "",
    client_ip: "",
    lot: "",
    label: "",
    start_date: "",
    end_date: "",
  });

  const [totalDataCount, setTotalDataCount] = useState(0);

  return (
    <StatusContext.Provider
      value={{
        selectedStatus,
        setSelectedStatus,
        page,
        setPage,
        imageList,
        setImageList,
        filters,
        setFilters,
        totalDataCount,
        setTotalDataCount,
      }}
    >
      {children}
    </StatusContext.Provider>
  );
};

export const useStatusContext = () => {
  const context = useContext(StatusContext);

  if (!context) {
    throw new Error("useStatusContext must be used inside StatusProvider");
  }

  return context;
};
